export const timeFormat = 'h:mm A';
export const dayName = 'dddd';
export const dayNameWithFullDate = 'dddd, DD/MM/YYYY';
export const fullDate = 'DD/MM/YYYY';
export const fullDateWithTime = 'DD/MM/YYYY | h:mm A';
export const dateGeneral = 'YYYY-MM-DDTHH:mm:ss';
